import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

import { AboUsersComponent } from "./abousers.component";
import { AboUsersService, AboUserConfigService, IAboUserConfigService } from "./abousers.service";
import { AboUserDetailComponent } from "./abouserdetail.component";
import { TranslateModule } from "@ngx-translate/core";
import { OAuthModule } from "@impacgroup/angular-oauth-base";
import { Route, RouterModule } from "@angular/router";
import { AboUsersMainComponent } from "./abousers.main.component";

@NgModule({
    declarations: [AboUsersMainComponent, AboUsersComponent, AboUserDetailComponent],
    imports: [CommonModule, RouterModule, FormsModule, BsDropdownModule, ModalModule, NgSelectModule, TranslateModule, OAuthModule, MatTableModule, MatPaginatorModule, MatSortModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    exports: [],
    providers: []
})
export class AboUsersModule {
    static forRoot(aboUserConfig: IAboUserConfigService): ModuleWithProviders<AboUsersModule> {
        // returns the services as singletons throughout the app (for lazy loading purposes)
        return {
            ngModule: AboUsersModule,
            providers: [
                AboUsersService,
                {
                    provide: AboUserConfigService,
                    useValue: aboUserConfig
                }
            ]
        };
    }

    static getRoutes(): Route[] {
        return [
            {
                path: "",
                component: AboUsersMainComponent,
                children: [
                    {
                        path: "",
                        component: AboUsersComponent
                    },
                    {
                        path: ":id",
                        component: AboUserDetailComponent
                    }
                ]
            }
        ];
    }
}
